import { FilterState, booleanFilter, customFilter, entityFilter, filter } from '@softapps/core/filter';
import { translator } from '@softline/ui-core';
import { QueryFilter } from '@softline/core';
import { AbcAnalysisFilterRow } from './abc-analysis-filter-row';

export const abcAnalysisFilter = (): FilterState<AbcAnalysisFilterRow> =>
  filter<AbcAnalysisFilterRow>({
    key: 'wws-abc-analysis',
    factory: (ref) => {
      const t = translator();
      // Dimension dropdowns backed by POST /statistics/abc-analysis/filter-values via
      entityFilter(ref, {
        field: 'sales_organisation',
        title: t('#WWS_ABC_ANALYSIS.FILTER.SALES_ORGANISATION'),
        icon: 'fa-regular fa-building',
        additionalFields: ['code', 'description'],
        formatter: (v) => `${v.code}`,
        sortField: 'code',
      });
      entityFilter(ref, {
        field: 'product_main_group',
        title: t('#WWS_ABC_ANALYSIS.FILTER.MAIN_GROUP'),
        icon: 'fa-regular fa-layer-group',
        additionalFields: ['description'],
        formatter: (v) => v.description,
        sortField: 'description',
      });
      entityFilter(ref, {
        field: 'product_sub_group',
        title: t('#WWS_ABC_ANALYSIS.FILTER.SUB_GROUP'),
        icon: 'fa-regular fa-layer-group',
        additionalFields: ['description'],
        formatter: (v) => v.description,
        sortField: 'description',
      });
      entityFilter(ref, {
        field: 'supplier',
        additionalFields: ['name'],
        title: t('#WWS_ABC_ANALYSIS.FILTER.SUPPLIER'),
        icon: 'fa-regular fa-truck-fast',
        sortField: 'name',
        formatter: (v) => v.name,
      });
      entityFilter(ref, {
        field: 'product_group',
        title: t('#WWS_ABC_ANALYSIS.FILTER.PRODUCT_GROUP'),
        icon: 'fa-regular fa-boxes-stacked',
        additionalFields: ['description'],
        formatter: (v) => v.description,
        sortField: 'description',
      });
      entityFilter(ref, {
        field: 'department',
        title: t('#WWS_ABC_ANALYSIS.FILTER.DEPARTMENT'),
        icon: 'fa-regular fa-sitemap',
        additionalFields: ['description'],
        formatter: (v) => v.description,
        sortField: 'description',
      });
      entityFilter(ref, {
        field: 'product',
        title: t('#WWS_ABC_ANALYSIS.FILTER.PRODUCT'),
        icon: 'fa-regular fa-box',
        additionalFields: ['number', 'description'],
        formatter: (v) => `${v.number} - ${v.description}`,
        sortField: 'id',
      });
      entityFilter(ref, {
        field: 'profit_center',
        title: t('#WWS_ABC_ANALYSIS.FILTER.COST_CENTER'),
        icon: 'fa-regular fa-chart-pie',
        additionalFields: ['description'],
        formatter: (v) => v.description,
        sortField: 'description',
      });
      entityFilter(ref, {
        field: 'promotion',
        title: t('#WWS_ABC_ANALYSIS.FILTER.PROMOTION'),
        icon: 'fa-regular fa-tags',
        additionalFields: ['description'],
        formatter: (v) => v.description,
        sortField: 'description',
      });
      customFilter(ref, {
        field: 'slowMoverOnly',
        title: t('#WWS_ABC_ANALYSIS.FILTER.SLOW_MOVER_ONLY'),
        icon: 'fa-regular fa-box-archive',
        defaultOperator: 'true',
        formatter: () => '',
        toQueryFilter: () =>
          ({ type: 'stringEquals', name: 'listed', value: 'P' }) as unknown as QueryFilter<AbcAnalysisFilterRow>,
      });
      booleanFilter(ref, {
        field: 'in_stock',
        title: t('#WWS_ABC_ANALYSIS.FILTER.IN_STOCK_ONLY'),
        icon: 'fa-regular fa-warehouse',
      });
      booleanFilter(ref, {
        field: 'in_active_promotion',
        title: t('#WWS_ABC_ANALYSIS.FILTER.IN_ACTIVE_PROMOTION_ONLY'),
        icon: 'fa-regular fa-tags',
      });
    },
  });
